<template>
  <g
    id="Left_Handlebar-4"
    v-on:click="changeSeverity('rearLeftHandlebar')"
    :class="severityClass"
  >
    <g>
      <path
        class="cls-707"
        d="M5.02,209.22c-.29-.06-.57-.06-.85-.04h0s-1.53,.15-1.53,.15h0c-1.19,.08-2.26,.91-2.56,2.13-.36,1.46,.53,2.91,1.99,3.23,.28,.06,.55,.06,.82,.04h0s1.55-.16,1.55-.16c.14,0,.27-.02,.41-.05h.04s0-.01,0-.01c1.01-.22,1.86-1,2.12-2.06,.36-1.46-.53-2.91-1.99-3.23Z"
      />
      <ellipse
        class="cls-441"
        cx="4.37"
        cy="211.87"
        rx="2.75"
        ry="2.68"
        transform="translate(-138.45 55.32) rotate(-41.19)"
      />
      <path
        class="cls-553"
        d="M23.51,210.95c.34-1.26-.41-2.53-1.67-2.83-.17-.04-.86-.04-.97-.02l-15.35,1.31c-1.22,.11-2.12,1.14-1.98,2.29l.06,.47c.13,1.12,1.19,1.94,2.38,1.84l15.1-1.27c1.3-.13,2.14-.69,2.43-1.8Z"
      />
      <path
        class="cls-441"
        d="M25.16,210.43c-.21-2.74-2.14-4.85-4.31-4.7-2.17,.15-3.75,2.5-3.54,5.24,.21,2.74,2.14,4.85,4.31,4.7,2.17-.15,3.75-2.5,3.54-5.24Z"
      />
      <path
        class="cls-553"
        d="M24.84,210.45c-.19-2.48-1.94-4.39-3.9-4.25-1.96,.14-3.39,2.26-3.2,4.74,.19,2.48,1.94,4.39,3.9,4.25s3.39-2.26,3.2-4.74Z"
      />
      <path
        class="cls-159"
        d="M43.16,221.36c-.43,0-.85-.17-1.17-.5l-6.38-6.83c-1.88-1.99-4.53-2.99-7.25-2.74l-5.76,.54c-.89,.08-1.67-.57-1.75-1.45-.08-.88,.57-1.67,1.45-1.75l5.76-.54c3.72-.35,7.32,1.01,9.89,3.73l6.38,6.83c.61,.65,.58,1.66-.07,2.27-.31,.29-.71,.44-1.1,.44Z"
      />
    </g>
    <path
      class="cls-553"
      d="M35.58,207.57v1.8c0,.18-.12,.35-.3,.4-1.16,.28-2.05,1.24-2.23,2.43-.03,.2-.21,.34-.41,.34h-2.7c-.52,0-.94-.42-.94-.94v-4.02c0-.41,.34-.75,.75-.75h5.08c.41,0,.74,.33,.74,.74Z"
    />
    <path
      class="cls-159"
      d="M43.43,217.69s3.05,3.67,7.71,3.67h9.81v3.09s-8.84-.05-11.79,0c-2.37,.04-4.02-.23-7.84-4.32"
    />
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
